import {UseCase} from "@livechat/shared";
import {AnswerTemplateAggregate} from "../aggregates";
import {AnswerTemplateGateway} from "../repositories";
import {map, Observable} from "rxjs";
import {AnswerTemplateDto} from "../../feature/answer-templates/domain/dtos";
import {answerTemplateAggregateToDto} from "../../feature/answer-templates/domain/utils";

export class CreateAnswerTemplateUseCase implements UseCase<AnswerTemplateAggregate, Observable<AnswerTemplateDto>> {

  constructor(private answerTemplateRepo: AnswerTemplateGateway) {
  }

  execute(answerTemplate: AnswerTemplateAggregate): Observable<AnswerTemplateDto> {
    return this.answerTemplateRepo.create(answerTemplate)
      .pipe(map(answerTemplateAggregateToDto));
  }
}
